"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSelectExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/input-select/examples/index.ts';
var countryInputSelect = _1.InputSelect.ofType();
var InputSelectExample = /** @class */ (function () {
    function InputSelectExample() {
        var _this = this;
        this.selectedItem = examples_1.countries[0];
        this.closeOnSelect = true;
        this.openOnDownKey = true;
        this.renderItem = function (item) { return (0, mithril_1.default)(_1.ListItem, {
            label: item.name,
            selected: _this.selectedItem && _this.selectedItem.name === item.name
        }); };
        this.handleSelect = function (item) { return _this.selectedItem = item; };
    }
    InputSelectExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(countryInputSelect, {
                closeOnSelect: this.closeOnSelect,
                items: examples_1.countries,
                itemRender: this.renderItem,
                itemPredicate: this.itemPredicate,
                onSelect: this.handleSelect,
                popoverAttrs: { hasArrow: false },
                value: this.selectedItem && this.selectedItem.name,
                openOnDownKey: this.openOnDownKey
            })
        ]);
    };
    InputSelectExample.prototype.itemPredicate = function (query, item) {
        return item.name.toLowerCase().includes(query.toLowerCase());
    };
    InputSelectExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)(_1.Switch, {
                checked: this.closeOnSelect,
                label: 'Close on select',
                onchange: function () { return _this.closeOnSelect = !_this.closeOnSelect; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.openOnDownKey,
                label: 'Open on down key',
                onchange: function () { return _this.openOnDownKey = !_this.openOnDownKey; }
            })
        ];
    };
    return InputSelectExample;
}());
exports.InputSelectExample = InputSelectExample;
